import React, { Fragment } from 'react';

export const handleNumberOfCount = (allConsents, id) => {
  const allAppointmentConsentLength = allConsents.length;
  const currentIndexConsent = allConsents.findIndex(item => {
    return item.id === id;
  });

  return (
    <Fragment>
      <span>{currentIndexConsent + 1}</span>
      <span>/{allAppointmentConsentLength}</span>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/utils/handleNumberOfCount.jsx